import React, { useState, useEffect } from 'react';
import {
    Button, Modal, ModalFooter,
    ModalHeader, ModalBody
} from 'reactstrap';
import { getFireFlowReports } from '../../services/api';
import FireFlowTestTableRow from './FireFlowTestTableRow';
import { makeFireFlowReport, makeFireFlowTestHydrant } from '../../models';

const FireFlowTestModal = ({ hydrantId, open, toggle, onSelect }) => {
  const [fireFlowReports, setFireFlowReports] = useState([]);

  useEffect(() => {
    setupFireFlowReports();
  }, [hydrantId]);

  const setupFireFlowReports = async () => {
    const result = await getFireFlowReports(hydrantId);
    const sortedResult = result.sort((a, b) => {
      if (a.testDate > b.testDate) {
        return -1;
      } else if (a.testDate < b.testDate) {
        return 1;
      } else {
        return 0;
      }
    });
    const mappedFireFlowReports = sortedResult.map(e => makeFireFlowReport(e));
    setFireFlowReports(mappedFireFlowReports);
  }

  const select = id => {
    toggle();
    onSelect(id);
  };

  const fireFlowTestHydrantRows = fireFlowReports?.map(fireFlowReport => 
    <FireFlowTestTableRow key={fireFlowReport.fireFlowTestHydrantId} report={fireFlowReport} onSelect={select} />);

  return (
    <Modal isOpen={open} toggle={toggle} size="lg">
      <ModalBody>
        <table className='table table-bordered'>
          <thead>
            <tr>
              <th>Test Date</th>
              <th>NFPA Color</th>
              <th>NFPA Classification</th>
              <th>Predicted GPM @ 20 PSI</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fireFlowTestHydrantRows}
          </tbody>
        </table>
      </ModalBody>
    </Modal>
  );
};

export default FireFlowTestModal;